import React from "react";
import { topicTags, occasions } from "../data/landing";
export function Overview() {
  return <section className="bg-cream" data-id="element-200" data-mp="1bwntsj5fvnv8">
      <div className="mx-auto grid max-w-6xl gap-8 px-5 py-12 md:px-8 md:py-24 lg:grid-cols-2 lg:gap-20" data-id="element-201" data-mp="1buuigqjvsfgw">
        <div data-id="element-202" data-mp="xvuull4704ls">
          <p className="text-sm font-semibold text-wine" data-id="element-203" data-mp="xyh4hrek2w76">Recursos Practic &amp; Simple</p>
          <h2 className="mt-2 font-display text-[28px] leading-tight text-forest md:mt-3 md:text-5xl" data-id="element-204" data-mp="12tmoulsb82t5">
            El Megapack de Recetas Festivas N°1 en Argentina
          </h2>
          <p className="mt-3 text-[15px] text-ink/80 md:mt-5 md:text-lg" data-id="element-205" data-mp="sy1th6hqy0sd">
            Sistema completo · 6 Tomos + 3 Bonos · Principiante e Intermedio · Todo resuelto.
          </p>
          <dl className="mt-5 grid grid-cols-3 gap-4 border-y border-line py-4 md:mt-10 md:gap-6 md:py-8" data-id="element-206" data-mp="j6p2eh3rvene">
            {[{
            v: "+50",
            l: "recetas"
          }, {
            v: "9",
            l: "tomos"
          }, {
            v: "Facíl",
            l: "Paso a paso"
          }].map(s => <div key={s.l} data-id="element-207" data-mp="axcufaf7x9jb">
                <dd className="font-display text-3xl text-wine md:text-5xl" data-id="element-208" data-mp="awkyfyhpl9si">{s.v}</dd>
                <dt className="mt-0.5 text-xs text-muted md:mt-1 md:text-sm" data-id="element-209" data-mp="5yt4z01f1fm7">{s.l}</dt>
              </div>)}
          </dl>
          <p className="mt-4 font-display text-lg italic leading-snug text-forest md:mt-8 md:text-xl" data-id="element-210" data-mp="jwzu9rsau7a9">
            Funciona desde hoy en tu cocina, con los ingredientes de tu supermercado más cercano.
          </p>
        </div>
        <div className="flex flex-col gap-6 md:gap-10" data-id="element-211" data-mp="3jehbzhbm1ens">
          <div data-id="element-212" data-mp="3jg27pa9nv3n8">
            <h3 className="text-sm font-semibold text-forest" data-id="element-213" data-mp="3jc4oypqzwe3v">Qué vas a encontrar</h3>
            <ul className="no-scrollbar -mx-5 mt-3 flex gap-2 overflow-x-auto px-5 md:mx-0 md:mt-4 md:flex-wrap md:overflow-visible md:px-0" data-id="element-214" data-mp="11j84zbp61oc">
              {topicTags.map(t => <li key={t} className="shrink-0 whitespace-nowrap rounded-full bg-paper px-3 py-1.5 text-[13px] text-ink ring-1 ring-line md:px-3.5 md:text-sm" data-id="element-215" data-mp="34o9ryx5yfnkz">
                  {t}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-forest p-5 text-paper md:p-8" data-id="element-216" data-mp="13mtu7grrdexh">
            <h3 className="font-display text-xl md:text-2xl" data-id="element-217" data-mp="18kvmmsb2qqlm">Festividades incluidas</h3>
            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 text-[13px] md:mt-5 md:gap-x-6 md:gap-y-3 md:text-sm" data-id="element-218" data-mp="1dcn5shrwhu1q">
              {occasions.map(o => <li key={o} className="flex items-center gap-2" data-id="element-219" data-mp="1ie2oi36lvogy">
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden data-id="element-220" data-mp="kp9b6qbodaks" />
                  {o}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}